import { useContext } from "react";
import { BlogContext, BlogContextType } from "../provider/BlogProvider";

export default function BlogPostCategories() {
  const { categories, filters, filterByCategory } = useContext(BlogContext) as BlogContextType;

  return (
    <div className="categories">
			<div className="title"><h6>Categories</h6></div>
			<ul className="list">
        { categories.length > 0 && categories.map((item, index) => {
            return (
              <li key={`category-${index}`} className={filters.category === item ? 'active' : ''}>
                <a href="#" onClick={() => filterByCategory(item)}>{item}</a>
            </li>
            )
          })
        }
			</ul>
		</div>
  )
}